const validationRoutes = [
  {
    path: "/validation",
    component: () =>
      import(
        /* webpackChunkName: "validation" */ "../components/validation/ValidationLayout.vue"
      ),
    children: [
      {
        path: "",
        name: "validation",
        component: () =>
          import(
            /* webpackChunkName: "validation" */ "../components/validation/Validation.vue"
          ),
      },
      {
        path: "authorization",
        name: "validation-authorization",
        component: () =>
          import(
            /* webpackChunkName: "validation" */ "../components/validation/ValidationWithAuth.vue"
          ),
      },
      {
        path: "history",
        name: "validation-history",
        component: () =>
          import(
            /* webpackChunkName: "validation" */ "../components/validation/ValidationHistory.vue"
          ),
      },
    ],
  },
];

export default validationRoutes;
